export function isNotNull<TValue>(value: TValue | null): value is TValue {
  return value !== null;
}
